import Vue from 'vue'
import Framework7 from 'Framework7';
import Framework7Vue from 'Framework7Vue';
import * as Sentry from '@sentry/vue';
import { BrowserTracing } from '@sentry/tracing';
import store from './store'
import httpRequest from './utils/httpRequest'
import commonJs from './utils/common-js'
import commonData from './utils/common-data'
import contentItem from './utils/contentItem'
import Moment from 'moment'
import Vconsole from 'vconsole';
import sanitizeHtml from 'sanitize-html'

import App from './App'
import router from './router'
import './assets/css/common.css'
import components from './components/'
import cErrorDialog from './components/Dialog/cErrorDialog'
import { getDocumentInfoForUrl } from '@/utils/common-api';

Sentry.init({
  Vue,
  dsn: process.env.SENTRY_DSN,
  environment: process.env.SENTRY_ENVIRONMENT,
  integrations: [
    new BrowserTracing({
      routingInstrumentation: Sentry.vueRouterInstrumentation(router),
      tracingOrigins: ['localhost', process.env.API, /^\//],
    }),
  ],
  // Set tracesSampleRate to 1.0 to capture 100%
  // of transactions for performance monitoring.
  // We recommend adjusting this value in production
  tracesSampleRate: process.env.SENTRY_TRACES_SAMPLE_RATE,
});

Object.keys(components).forEach((key) => {
  var name = key.replace(/(\w)/, (v) => v.toUpperCase())
  Vue.component(name, components[key])
})

Vue.config.productionTip = false



if(!['stg','prod'].includes(process.env.VueJsJSEnv)){
  new Vconsole();
}

Framework7.use(Framework7Vue);
Vue.prototype.commonJs = commonJs;
Vue.prototype.commonData = commonData;
Vue.prototype.contentItem = contentItem;
Vue.prototype.axios = httpRequest;
Moment.locale('ja');
Vue.prototype.Moment = Moment;
Vue.prototype.$cErrorDialog = cErrorDialog;
Vue.prototype.$sanitize = sanitizeHtml;
Vue.prototype.env = process.env
 
// クライアントが構成を変更できないようにする
Object.freeze(window.Vue.prototype.env);




Vue.directive('disableEmojiInput', {
  bind: commonJs.disableEmojiInput
})

Vue.directive('eventScroll', {
  bind: commonJs.eventScroll
})

let firstVisit = true

//画面切り替え時に呼び出される関数
router.beforeEach((to, from, next) => {

  // 前のページのアクセス履歴を保存します。これは、後続のページでソースを判断するのに便利です
  if(from.path != '/') sessionStorage.setItem('prevPageRoute',from.path)

  // console.log('router.beforeEach to: ' + to.path + ', from: ' + from.path);
  // 口座開設申込URL直叩き制御
  // let local_email = commonJs.getLocalData('email');
  // console.log('stoData[email]: ' + local_email ? local_email.email : 'undefined');
  // console.log('currentPage: ' + commonJs.getLocalData('currentPage'));

  // 個人は、REQUEST_SEQ_NO データのページを確認する必要があります
  let personalCheck = [
    '/identityDocumentsType',
    '/myNumberUpload',
    '/onlineConfirm',
  ]
  // 法人が REQUEST_SEQ_NO データを確認する必要があるページ
  let companyCheck = [
    '/representativeIdentityDocumentsUpload',
    '/representativeIdentityDocumentsType',
    '/rulerIdentityDocumentsUpload',
    '/transactionManagerIdentityDocumentsUpload',
    '/transactionManagerIdentityDocumentsType'
  ]

  let personalCheckStatus = personalCheck.indexOf(to.path) != -1 
  let companyCheckStatus = companyCheck.indexOf(to.path) != -1 


  let localUserInfo = commonJs.getLocalLowerData('user','userRequestInfo') || {}
  
  // localStorage にユーザー関連の REQUEST_SEQ_NO パラメータがないことが検出された場合、R-001 配信ページにジャンプします

  if(personalCheckStatus || companyCheckStatus){

    if(!localUserInfo.USER_REQUEST_SEQ_HASH_NO){
      // コードを読み取るとS-001の画面にそのまま入る状況があるため、
      // エラーメッセージを表示せずにそのままR-001に画面を遷移させる
      if(to.path == '/identityDocumentsType'){
        next({
          path: '/documentVerifySetEmail'
        });
      }else{
        cErrorDialog({
          title: '',
          left: 'cancel',
          right: 'OK',
          content: 'お手数ですが、「OK」ボタン押下後に表示される画面からやり直してください。※お手続きは、必ず同じブラウザでお進みください。',
          cancelBtn: false,
          confirm: () => {
            next({
              path: '/documentVerifySetEmail'
            });
          }
        })
      }
      
      return
    }else if(from.fullPath == '/' && firstVisit){

      getDocumentInfoForUrl('',localUserInfo.USER_REQUEST_SEQ_HASH_NO).then(res=>{

        if(res.data.STATUS == 'OK'){
          next({
            path: res.url
          });
        }else{
          cErrorDialog({
            title: '',
            left: 'cancel',
            right: 'OK',
            content: res.data.ERROR.MESSAGE,
            cancelBtn: false,
            confirm: () => {
              next({
                path: '/documentVerifySetEmail'
              });
            }
          })
        }
      });
      firstVisit = false
      return
    }
  }

  const reload_pages = ['/setEmail'];
  if ( reload_pages.includes(to.path) && from.path != '/') {
    window.location.href = to.fullPath;
    return;
  }


  if (to.meta.requireAuth) { // 判断该路由当前是否进入权限
    let submitFlag = JSON.parse(localStorage.getItem('submitFlag'));  // 確認画面で一度提出した後に再度戻した場合の対策

    if (!localStorage.getItem('submitFlag')) {
      if (!localStorage.getItem('stoData')) { // submitFlagとstoDataどれもない場合、ルートURLに遷移させる。
        next({
          path: '/'
        });
      }
      try {
        let validation_seq_no = JSON.parse(localStorage.getItem('stoData')).VALIDATION_SEQ_NO;
        localStorage.setItem('submitFlag', JSON.stringify({ VALIDATION_SEQ_NO: validation_seq_no, REQUEST_SEQ_NO: 0 }))

        submitFlag = JSON.parse(localStorage.getItem('submitFlag'));

      } catch (e) {
        // console.error(e)
      }

    }
    if (submitFlag.VALIDATION_SEQ_NO && submitFlag.REQUEST_SEQ_NO == 0 && sessionStorage.getItem('VALIDATION_HASH_CODE')== submitFlag.VALIDATION_SEQ_NO) { //判断本地是否存在HASH_CODE
      if((from.path === '/' || from.path === '/transferPage') && commonJs.getLocalData('currentPage') && to.path !== commonJs.getLocalData('currentPage')) {  // URL直叩きの場合、前回進んだ画面に遷移させる
        next({
          path: commonJs.getLocalData('currentPage')
        })
      } else {
        next();
      }
    } else {
      next({
        path: '/'
      })
    }
  } else if((to.path === '/transferPage') && sessionStorage.getItem('VALIDATION_HASH_CODE') &&  commonJs.getLocalData('currentPage') && to.path !== commonJs.getLocalData('currentPage')) {  // URL直叩きの場合、前回進んだ画面に遷移させる

    let submitFlag = JSON.parse(localStorage.getItem('submitFlag'));
    if (to.query.HASH_CODE && to.query.HASH_CODE != submitFlag.VALIDATION_SEQ_NO ) {
      //当邀请邮件进入界面并submitFlag存在，url的hash_code不等与submitFlag.VALIDATION_SEQ_NO已新界面信息为主
      localStorage.setItem('submitFlag', JSON.stringify({VALIDATION_SEQ_NO: to.query.HASH_CODE, REQUEST_SEQ_NO: 0}))
      next();
    }else{
      //submitFlag.VALIDATION_SEQ_NO 等于 stoData.VALIDATION_SEQ_NO 就进入当前界面
      if(submitFlag.VALIDATION_SEQ_NO == commonJs.getLocalData('VALIDATION_SEQ_NO')){
        next({
          path: commonJs.getLocalData('currentPage')
        })

      }else{
        //进入首页
        next({
          path: '/'
        })
      }
    }
  } else {
    next();
  }
});


window.vm=new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})


// WEBPACK FOOTER //
// ./src/main.js